import { Routes } from '@angular/router';
import { authGuard, unlockedGuard } from './core/auth.guard';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
  {
    path: 'register',
    loadComponent: () => import('./features/auth/register').then((m) => m.RegisterComponent)
  },
  {
    path: 'privacy',
    loadComponent: () => import('./features/legal/privacy').then((m) => m.PrivacyComponent)
  },
  {
    path: 'confirm-email',
    loadComponent: () =>
      import('./features/auth/confirm-email').then((m) => m.ConfirmEmailComponent)
  },
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login').then((m) => m.LoginComponent)
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./features/auth/forgot-password').then((m) => m.ForgotPasswordComponent)
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./features/auth/reset-password').then((m) => m.ResetPasswordComponent)
  },
  {
    path: 'unlock',
    canActivate: [authGuard],
    loadComponent: () => import('./features/auth/unlock').then((m) => m.UnlockComponent)
  },
  {
    path: 'dashboard',
    canActivate: [authGuard, unlockedGuard],
    loadComponent: () =>
      import('./features/dashboard/dashboard').then((m) => m.DashboardComponent)
  },
  {
    path: 'profile',
    canActivate: [authGuard],
    loadComponent: () => import('./features/profile/profile').then((m) => m.ProfileComponent)
  },
  {
    path: 'social',
    canActivate: [authGuard],
    loadComponent: () => import('./features/social/social').then((m) => m.SocialComponent)
  },
  {
    path: 'add-friend',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/social/add-friend').then((m) => m.AddFriendComponent)
  },
  { path: '**', redirectTo: 'dashboard' }
];
